// console.log(process.env);
export default {
	jobApiUrl : {
		href : 'https://jobs.race.id/api/',
		// href : 'http://localhost:9922/api/',
	},
	steelytoeUrl : {
		href : 'https://admin.borobudurmarathon.com/dev.titudev.com/api/v1/',
	},
	validatorUrl : {
		href : 'https://validator.race.id/',
	},
	utilityUrl : {
		href : 'https://utilities.race.id/file/',
		// href : 'http://localhost:8082/',
	}
};



// WEBPACK FOOTER //
// src/config.url.js